/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import DataConnector from 'connect/DataConnector';
import FileStates, {SequenceFileState} from 'FileStates';
import notifications from 'notifications';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import {ButtonStyle} from 'ui-library/buttons/Button';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import Modal from 'ui-library/modals/Modal';

import CreateSequenceStep from './CreateSequenceStep';
// @ts-expect-error
import CRISPRAnalysisActions from './CRISPRAnalysisActions';
import CRISPRAnalysisStore from './CRISPRAnalysisStore';
import CRISPRAnalysisTabState from './CRISPRAnalysisTabState';
import CRISPRIASettingsForm from './CRISPRIASettingsForm';
import SetDefaultsInput from './SetDefaultsInput';
import SettingsForm from './SettingsForm';

const CRISPR_MODAL_KEY = 'CRISPRModal';

export function openCRISPRModal(param: any): ReturnType<typeof LegacyModalContainer.open> {
  if (param == null) {
    param = {};
  }
  const {sequenceId, onClose} = param;
  return LegacyModalContainer.open(
    CRISPR_MODAL_KEY,
    <ConnectedCRISPRModal
      onRequestClose={function () {
        if (typeof onClose === 'function') {
          onClose();
        }
        LegacyModalContainer.close(CRISPR_MODAL_KEY);
      }}
      initialSequenceId={sequenceId}
    />
  );
}

class CRISPRModalConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [CRISPRAnalysisStore];

  enhanceProps(): EnhancedProps {
    return {cidIdMap: this.crisprAnalysisStore().getState().cidIdMap};
  }
}

interface Props {
  onRequestClose: () => void;
  initialSequenceId?: string | null;
}
interface EnhancedProps {
  cidIdMap: any;
}

type State = any;

class CRISPRModal extends React.Component<Props & EnhancedProps, State> {
  static defaultProps = {
    initialSequenceId: null,
  };

  _isMounted: any;

  sequenceStepRef = React.createRef<CreateSequenceStep>();
  setDefaultsInputRef = React.createRef<SetDefaultsInput>();
  settingsFormRef = React.createRef<SettingsForm | CRISPRIASettingsForm>();

  override state: State = {
    genome: null,
    isCrisprIa: false,
    sequenceId: this.props.initialSequenceId,
    submitted: false,
    formValidated: true,
    analysisCid: _.uniqueId('crispr-analysis-'),
  };

  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentDidUpdate(): void {
    const analysisId = this.props.cidIdMap[this.state.analysisCid];
    if (analysisId != null) {
      const fileStates = FileStates.get();
      const sequenceFile = fileStates.get(this.state.sequenceId) as SequenceFileState;
      const existingTab = sequenceFile.findTab(
        CRISPRAnalysisTabState,
        (tab: CRISPRAnalysisTabState) => tab.analysisId() === analysisId
      );
      if (existingTab != null) {
        existingTab.set({active: true});
      } else {
        const sequence = sequenceFile.model();
        sequenceFile.buffers().addTab(new CRISPRAnalysisTabState({analysisId, sequence}));
      }
      this.props.onRequestClose();
    }
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  getSubtitle = (): string => {
    if (this.state.sequenceId != null) {
      return 'Guide parameters';
    } else {
      return 'Import sequence';
    }
  };

  createSequence = (): void => {
    const deferred = this.sequenceStepRef.current!.createSequence();
    analytics.track('crispr', 'modal_created_sequence');
    if (deferred == null) {
      return;
    }

    LoadingScreen.show();
    Promise.resolve(deferred)
      .then((sequenceId: any) => {
        if (this._isMounted) {
          return FileStates.get().openFolderItem(sequenceId, {open: true, source: 'crispr-analysis'});
        }
        return undefined;
      })
      .then((fileState: any) => {
        if (this._isMounted && fileState != null) {
          this.setState({sequenceId: fileState.id, genome: this.sequenceStepRef.current!.getGenome()});
        }
      })
      .catch(notifications.notifyError)
      .finally(() => {
        LoadingScreen.hide();
      });
  };

  submit = (): void => {
    if (this.setDefaultsInputRef.current != null && this.settingsFormRef.current != null) {
      this.setDefaultsInputRef.current.setDefaults(this.settingsFormRef.current.getAllSettings());
    }
    const analysis = this.settingsFormRef.current!.getAnalysisSettings();
    CRISPRAnalysisActions.create(
      this.state.analysisCid,
      // eslint-disable-next-line no-restricted-syntax
      _.extend({}, analysis, {sequence: this.state.sequenceId})
    );
    analytics.track('crispr', 'modal_finished_settings');
    this.setState({submitted: true});
  };

  setValid = (valid: any): void => {
    this.setState({formValidated: valid});
  };

  override render(): JSX.Element {
    let button;
    if (this.state.sequenceId != null) {
      button = {
        text: this.state.submitted ? 'Creating...' : 'Finish',
        submit: true,
        disabled: this.state.submitted || !this.state.formValidated,
      };
    } else {
      button = {
        text: 'Next',
        style: ButtonStyle.PRIMARY,
        onClick: this.createSequence,
        dataTestAttrs: {
          component: 'CRISPRModal',
          element: 'footerButton',
          key: ModalButtonKey.NEXT,
        },
      };
    }
    return (
      <Modal
        enableRedesign={true}
        key={this.state.sequenceId == null ? 'step-1' : 'step-2'}
        title={`Design CRISPR guides: ${this.getSubtitle()}`}
        onRequestSubmit={this.state.sequenceId != null ? this.submit : undefined}
        onRequestClose={this.props.onRequestClose}
        wrapInForm={this.state.sequenceId != null}
        buttons={[button]}
        footer={
          this.state.sequenceId != null && !this.state.isCrisprIa ? (
            <SetDefaultsInput
              disabled={false}
              initialShouldSetDefaults={true}
              ref={this.setDefaultsInputRef}
            />
          ) : undefined
        }
        dataTestAttrs={{component: 'CRISPRModal', element: 'modal'}}
      >
        {this.state.sequenceId != null ? (
          this.state.isCrisprIa ? (
            <CRISPRIASettingsForm
              ref={this.settingsFormRef as React.RefObject<CRISPRIASettingsForm>}
              initialGenome={this.state.genome}
            />
          ) : (
            <SettingsForm
              ref={this.settingsFormRef as React.RefObject<SettingsForm>}
              setValid={this.setValid}
              allowEdits={true}
              initialGenome={this.state.genome}
            />
          )
        ) : (
          <CreateSequenceStep
            ref={this.sequenceStepRef}
            onChangeIsCrisprIa={(isCrisprIa) => {
              this.setState({isCrisprIa});
            }}
          />
        )}
      </Modal>
    );
  }
}

const ConnectedCRISPRModal = CRISPRModalConnector.connect(CRISPRModal);

export default ConnectedCRISPRModal;
